import React from 'react';

import { Link } from 'react-router-dom';

import AddFavorite from 'components/AddFavorite';
import { ResourceTile } from 'components/ResourceTile/ResourceTile';
import WebsiteSplitter from 'components/WebsiteSplitter';

const FavoriteLink = (props) => {
  const {
    image,
    pageID,
    chapter,
    page: trainingPage,
    sub_type,
    subType: subTypeCamel,
    subtitle,
    title,
    type: originType,
  } = props.info;

  const subType = sub_type || subTypeCamel;
  const { favorites } = props;
  const { unid, type, app_id: appId } = props.contentInfo;

  const url =
    typeof props.info.url === 'string' && props.info.url.includes(',') ? props.info.url.split(',') : props.info.url;

  const resolvedUrl = Array.isArray(url) ? url[0] : url;

  const cardChildren = (
    <React.Fragment>
      <div className="favorite__image--container">
        <img src={image} alt={unid} />
      </div>
      <h4>{title}</h4>
      <p>{subtitle}</p>
    </React.Fragment>
  );

  const isHardcodedResource =
    resolvedUrl?.includes('travpro.yourworldapps.nl/directory/thailand_dir/map') ||
    resolvedUrl?.includes('stack.travpromobile.com/instagram.php?embed_id=') ||
    resolvedUrl?.includes('thaitheknotspecialist.com/main/sell/templates-mobile');

  const inner =
    type === 'p' && !isHardcodedResource ? (
      <Link to={`ret/chapter/${chapter}/${trainingPage - 1}`} className="favorite__button">
        {cardChildren}
      </Link>
    ) : (
      <ResourceTile
        type={subType}
        url={url}
        title={title}
        subtitle={subtitle}
        image={image}
        appId={appId}
        uniqueId={pageID}
        locked={false}
        className="favorite__button"
        zoomOnHover={true}
      >
        {cardChildren}
      </ResourceTile>
    );

  return (
    <div className="favorite__card" key={pageID}>
      <AddFavorite appId={appId} favorites={favorites} viewType={type} upID={unid} color />
      {inner}
      {subType === 'multi' && (
        <WebsiteSplitter itemID={pageID} appID={appId} type={originType !== 'toolbox' ? 'FastFacts' : originType} />
      )}
    </div>
  );
};

export default FavoriteLink;
